import React from 'react';
import { Button, Modal } from 'gatorcomponents';
import * as Styles from './RebootModal.styles';
import useLocale from '@/hooks/useLocale';
import { useSelector } from 'react-redux';
import { useResize } from '@/hooks/useResize';

const RebootModal = ({ onClose, onConfirm, onCheckRebootHistory }) => {
  const { productDetails: productDetailsLocale } = useLocale();
  const { vpsOci: locale } = productDetailsLocale;
  const vpsOci = useSelector(state => state.vpsOci);

  const windowRect = useResize();
  const { width } = windowRect;
  const isMobile = width < 600;

  return (
    <Modal onClose={onClose} maxWidth={800} title={locale.myPlan.rebootModal.title} testId="reboot-modal">
      <Styles.Container>
        <Styles.Message data-testid="reboot-modal-message">
          {locale.myPlan.rebootModal.message(vpsOci.data.productName)}
        </Styles.Message>
        <Styles.Actions>
          <Button
            label={locale.myPlan.rebootModal.cancel}
            variant="tertiary"
            size="medium2"
            onClick={onClose}
            width={isMobile ? 'full' : 'fit-content'}
            testId="reboot-modal-cancel-button"
          />
          <Button
            label={locale.myPlan.rebootModal.checkRebootHistory}
            variant="secondary"
            size="medium2"
            onClick={onCheckRebootHistory}
            width={isMobile ? 'full' : 'fit-content'}
            testId="reboot-modal-check-history-button"
          />
          <Button
            label={locale.myPlan.rebootModal.confirm}
            variant="primary"
            size="medium2"
            onClick={onConfirm}
            width={isMobile ? 'full' : 'fit-content'}
            testId="reboot-modal-confirm-button"
          />
        </Styles.Actions>
      </Styles.Container>
    </Modal>
  );
};

export default RebootModal;
